export type PageStatus = 'success' | 'warning' | 'error' | 'neutral';

export const STATUS_LABELS: Record<PageStatus, string> = {
  success: 'Ready for Dev',
  warning: 'In the Work',
  error: "Don't use",
  neutral: 'Not Available',
};

export const PAGE_STATUS_BY_ROUTE: Record<string, PageStatus> = {
  '/variables/colors': 'success',
  '/variables/typography': 'success',
  '/variables/spacing': 'neutral',
  '/variables/shadows': 'success',
  '/variables/corner-radius': 'success',
  '/components/buttons': 'success',
  '/components/icons': 'success',
  '/components/top-bar': 'warning',
  '/components/avatars': 'neutral',
  '/components/pills': 'success',
  '/components/navigation': 'warning',
  '/components/navigation/desktop': 'warning',
  '/components/navigation/mobile': 'warning',
};

export function getPageStatus(route: string): PageStatus {
  return PAGE_STATUS_BY_ROUTE[route] ?? 'success';
}
